import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  /* eslint-disable-next-line @angular-eslint/component-selector */
  selector: 'cc-input-dropdown',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './input-dropdown.component.html',
})
export class InputDropdownComponent {
  // @ts-expect-error
  @Input() label: string;
  // @ts-expect-error
  @Input() items: any[];
  @Input() currentItem: any;
  @Output() itemSelected = new EventEmitter<any>();

  handleClick(tab: any) {
    this.itemSelected.emit(tab);
  }
  constructor() {}
}
